import React from "react";

import Motto1 from "../assets/motto1.png";
import { AppButton } from "../utils";
import { Link } from "react-router-dom";

function Intro(props) {
  return (
    <div
      className="bg-white w-full h-auto my-32 xs:mt-64 sm:mt-96 mt-[200px]"
      style={{ marginTop: "34rem" }}
    >
      {/* <Motto className="mx-auto" /> */}
      <img className="-mb-20" src={Motto1} alt="" />
      <h2 className="font-semibold font-montserrat text-5xl text-center mt-8 text-mix-400 px-4">
        We're on a mission of big changes
      </h2>
      <p className="font-normal font-montserrat text-xl text-center w-4/6 mx-auto mt-16">
        We are on a journey to make this world a better place , on all grounds.
        We have initiated several projects to fulfill this goal in different
        aspects of services, both to the Earth and its dwellers. We intend to
        continue this way and progress everyday. We currently have{" "}
        <span className="font-semibold">120+ members</span> working with us. The
        one thing that brings us all together is the will to serve.
        <span className="block font-montserrat font-semibold text-2xl text-mix-400 uppercase">
          Inspire. Serve. Impact.
        </span>
      </p>
      <div className="flex justify-center items-center mt-12 md:mt-20 mb-20">
        <Link to="/about">
          <AppButton text="Know More" />
        </Link>
      </div>
    </div>
  );
}

export default Intro;